import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updateProfile,
  onAuthStateChanged,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithRedirect,
  signInWithPopup,
  getRedirectResult,
} from 'firebase/auth';
import { auth } from './config';
import { addUserProfile } from './firestore';

export const login = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

export const register = async (email, password, displayName, role = 'counsellor') => {
  const cred = await createUserWithEmailAndPassword(auth, email, password);
  await updateProfile(cred.user, { displayName });
  await addUserProfile(cred.user.uid, {
    name: displayName,
    email,
    role,
    avatar: { bg: '#7c3aed', color: '#fff' },
  });
  return cred;
};

export const logout = () => signOut(auth);

export const resetPassword = (email) => sendPasswordResetEmail(auth, email);

export const onAuthChange = (callback) => onAuthStateChanged(auth, callback);

// ─── SOCIAL SIGN-IN ───────────────────────────────────────────────────────────
// Google: popup WITHOUT prompt:'select_account'.
// prompt:'select_account' forces an extra account-chooser navigation inside the
// popup, which triggers Firebase's premature popup-closed detection. Removing it
// lets Google auto-select the signed-in account (or show the normal sign-in page
// if not signed in), keeping the popup flow to a single redirect so the
// postMessage handshake completes before the popup closes.
export const signInWithGoogle = () => {
  const provider = new GoogleAuthProvider();
  return signInWithPopup(auth, provider);
};

// Microsoft: popup (redirect is unreliable for Microsoft OAuth across custom domains
// because Firebase uses a cross-origin iframe to return the result, which silently
// fails when authDomain !== app domain. Popup is direct and always returns a result.)
export const signInWithMicrosoft = () => {
  const provider = new OAuthProvider('microsoft.com');
  provider.setCustomParameters({ prompt: 'select_account' });
  return signInWithPopup(auth, provider);
};

// Call this on Login mount to catch the Google redirect result when it returns
export const getOAuthRedirectResult = () => getRedirectResult(auth);
